import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfe67f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-tools-editor" }
const _hoisted_2 = { class: "list-unstyled" }
const _hoisted_3 = { class: "category-header" }
const _hoisted_4 = { class: "list-unstyled" }
const _hoisted_5 = ["checked", "onChange"]
const _hoisted_6 = ["src"]

import { ResearchToolCategory, researchToolCategoryNames, researchToolInfos } from '@/rd/ResearchTools'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchToolsEditor',
  props: {
    modelValue: {}
  },
  emits: [
  'update:modelValue'
],
  setup(__props: any, { emit }) {

const props = __props;





const categories = Object.keys(ResearchToolCategory)
  .map(key => ResearchToolCategory[key as keyof typeof ResearchToolCategory])
  .filter(value => typeof value == 'number')

function catTools(cat: ResearchToolCategory) {
  return researchToolInfos
    .filter(t => t.category === cat)
    .sort((a, b) => a.name.localeCompare(b.name))
}

function isSelected(id: string) {
  return !!props.modelValue?.includes(id)
}

function onSelectedChanged(e: Event, id: string) {
  const checkbox = e.target as HTMLInputElement
  const otherSelected = (props.modelValue ?? []).filter(t => t != id)
  if (checkbox.checked) {
    emit('update:modelValue', [...otherSelected, id]) // add
  } else {
    emit('update:modelValue', otherSelected) // remove
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (cat) => {
        return (_openBlock(), _createElementBlock("li", {
          key: cat,
          class: "category"
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(researchToolCategoryNames)[cat]), 1),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catTools(cat), (t) => {
              return (_openBlock(), _createElementBlock("li", {
                key: t.id,
                class: "research-tool"
              }, [
                _createElementVNode("label", {
                  class: _normalizeClass({ checked: isSelected(t.id) })
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    checked: isSelected(t.id),
                    onChange: e => onSelectedChanged(e, t.id)
                  }, null, 40, _hoisted_5),
                  _createElementVNode("img", {
                    src: t.icon
                  }, null, 8, _hoisted_6),
                  _createTextVNode(" " + _toDisplayString(t.name), 1)
                ], 2)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})